import VendorAttestations from "@/views/client/VendorAttestations.vue";
import OnboardingPage from "@/views/client/OnboardingPage.vue";
import WorkflowPage from "@/views/client/WorkflowPage.vue";

import { CLIENT_ROLE } from "@/services/constants";
import WorkflowStepResolutionPage from "@/views/client/WorkflowStepResolutionPage.vue";

const clientDashboard = {
  path: "/client-dashboard",
  name: "clientDashboard",
  href: "/client/dashboard",
  meta: {
    humanName: "Dashboard",
    navbarMenu: {
      name: "Dashboard",
      order: 1,
      href: "/client/dashboard"
    },
    role: CLIENT_ROLE
  }
};

const vendors = {
  path: "/client-vendors",
  name: "clientVendors",
  href: "/client/manage/vendors",
  meta: {
    humanName: "Vendors",
    navbarMenu: {
      name: "Vendors",
      order: 2,
      href: "/client/manage/vendors"
    },
    role: CLIENT_ROLE
  }
};

const clientUsers = {
  path: "/client-users",
  name: "clientUsers",
  href: "/client/manage/users",
  meta: {
    humanName: "Users",
    navbarMenu: {
      name: "Users",
      order: 3,
      href: "/client/manage/users",
      permission: {
        UsersAccess: true
      }
    },
    role: CLIENT_ROLE
  }
};

const clientImport = {
  path: "/client-import",
  name: "clientImport",
  href: "/client/manage/import",
  meta: {
    humanName: "Import",
    navbarMenu: {
      name: "Import",
      order: 4,
      href: "/client/manage/import",
      permission: {
        ImportsAccess: true
      }
    },
    role: CLIENT_ROLE
  }
};

const clientReports = {
  path: "/client-reports",
  name: "clientReports",
  href: "/client/manage/reports",
  meta: {
    humanName: "Reports",
    navbarMenu: {
      name: "Reports",
      order: 5,
      href: "/client/manage/reports"
    },
    role: CLIENT_ROLE
  }
};

const clientAttestationsRoute = {
  path: "/client/attestations",
  name: "attestations",
  component: VendorAttestations,
  meta: {
    humanName: "Attestations",
    navbarMenu: {
      name: "Attestations",
      order: 6,
      permission: {
        VendorProofEngage: true,
        Attestations: true
      },
      role: CLIENT_ROLE
    }
  }
};

const waivers = {
  path: "/client-waivers",
  name: "waivers",
  href: "/client/manage/waivers",
  meta: {
    humanName: "Waivers",
    navbarMenu: {
      name: "Waivers",
      order: 8,
      href: "/client/manage/waivers",
      permission: {
        PaymentWaiverAccess: true
      }
    },
    role: CLIENT_ROLE
  }
};

const clientEnrollmentRoute = {
  path: "/client/enrollment",
  redirect: "/client/attestations"
};

const onboarding = {
  path: "/client/manage/onboard",
  name: "onboarding",
  component: OnboardingPage,
  meta: {
    humanName: "Onboarding",
    navbarMenu: {
      name: "Onboarding",
      order: 7,
      permission: {
        VendorProofEngage: true,
        Onboarding: true
      },
      role: CLIENT_ROLE
    }
  }
};

const workflow = {
  path: "/client/manage/onboard/:covgId",
  name: "workflow",
  component: WorkflowPage,
  props: true,
  meta: {
    humanName: "Vendor Workflow",
    role: CLIENT_ROLE
  }
};

const workflowStep = {
  path: "/client/manage/onboard/:covgId/step/:itemId",
  name: "workflowStep",
  component: WorkflowStepResolutionPage,
  props: true,
  meta: {
    humanName: "Workflow Step Resolution",
    role: CLIENT_ROLE
  }
};

export const defaultClientRoute = clientDashboard;

export const ClientRoutes = [
  clientDashboard,
  vendors,
  clientUsers,
  clientImport,
  clientReports,
  clientAttestationsRoute,
  onboarding,
  workflow,
  workflowStep,
  waivers,
  clientEnrollmentRoute
];
